<div *ngIf="selecionado">
  <app-margem-mo-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-margem-mo-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-margem-mo-filtro [filtros]="filtros"></app-margem-mo-filtro>
  <app-margem-mo-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-margem-mo-lista>
</div>